<div class="task_tempalte_fix">
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Add Task Template        
    <button mat-icon-button (click)="closeAll()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>
  
  <mat-dialog-content>
   
  
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetails($event)">
      <mat-tab label="TaskList Template">
  
        <div class="tabContainer">
          <div class="d-flex">               
          
              <div class="template-holder">
                <div class="left">
          
                  <mat-form-field appearance="fill">
                    <mat-label>Select Category</mat-label>
                    <mat-select (selectionChange)="onTaskListTabChange($event)" value="My Template" >
                      <mat-option value="My Template">My Template</mat-option>
                      <mat-option value="Organization">Organization</mat-option>
                      <mat-option value="Global">Global</mat-option>
                    </mat-select>
                  </mat-form-field>
          
                  <div class="list" #categoryList>
                    <ul>
                      <li (click)="getTaskListThroughCategory(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
                      <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
                        <li (click)="getTaskListThroughCategory(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
                      </ng-container>           
                    </ul>
                  
                  </div>
          
                </div>
               <div class="right"> 
                 
                 <div class="searrch">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Search</mat-label>
                    <input matInput maxlength="20" placeholder="search template"
                      (input)="searchTemplate($event.target.value)">
                  </mat-form-field>
                 </div>
            
                 <div class="list">
          
                  <div class="tempalteList">
                    <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                      <tr>
                        <th>Template Name</th>             
                        <th class="actBtn">Action</th>
                      </tr>
                      <tr *ngFor="let template of FilteredTaskTemplatesList"
                        [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">
          
                        <td class="formName">
                          {{template.taskTemplateName}}
                        </td>            
          
                        <td>
                          <span class="import" (click)="SelectTaskListTemplates(template)">Select</span>
                          <!-- <span class="import" (click)="SelectTemplate(template)" >Import</span> -->
                        </td>
                      </tr>
                    </table>
                    <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
                  </div>
          
                 </div>
            
               </div>
            </div>  
  
          </div>
       
        </div>
      </mat-tab>
  
      <mat-tab label="Single Task Template">
        <div class="tabContainer">
          
            <div class="template-holder">
              <div class="left">
        
                <mat-form-field appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
                    <mat-option value="My Template">My Template</mat-option>
                    <mat-option value="Organization">Organization</mat-option>                 
                  </mat-select>
                </mat-form-field>
        
                <div class="list" #categoryList>
                  <ul>
                    <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
                    <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
                      <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
                    </ng-container>           
                  </ul>
                
                </div>
        
              </div>
             <div class="right"> 
               
              
        
               <div class="searrch">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" placeholder="Search Template"
                    (input)="searchTemplateForSingleTask($event.target.value)">
                </mat-form-field>
               </div>
          
               <div class="list">
        
                <div class="tempalteList">
                  <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                    <tr>
                      <th>&nbsp;</th>
                      <th>Template Name</th>             
                      <th class="">&nbsp;</th>
                    </tr>
                    <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
                     [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">
        
                     <td>
                      <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
                      </mat-checkbox>
                    </td> 
        
                      <td class="formName">
                        {{template.templateName}}
                      </td>            
        
                      <td>
                        &nbsp;
                      </td>
                    </tr>
                  </table>
                  <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
                </div>
        
               </div>
          
             </div>
          </div>  
         
        </div>
  
      </mat-tab>
    </mat-tab-group>
  
  </mat-dialog-content>
  
  <section class="importTo" *ngIf="taskListTemplateID>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>
  
  <mat-dialog-actions>
    <button mat-button (click)="closeAll()">Cancel</button>  
    <button mat-stroked-button color="primary" class="import" *ngIf="selectedTemplate.length>0" 
      (click)="importTaskTemplates()">Import
    </button>  

    <button mat-stroked-button color="primary" class="import" *ngIf="taskListTemplateID>0"
      (click)="importTaskListTemplates()">Import
    </button> 

  </mat-dialog-actions>
</div>




